import axios from './axios';
import { convertEmptyToNull } from '../helpers/stringHandler';

export const MESSAGES_AND_ACTION_LOGS = 'MESSAGES_AND_ACTION_LOGS';

interface IrisEquipmentGroupsResponse {
  equipment_groups: { classifier: string; group?: string | null }[];
}

export const getEquipmentGroupNames = ({ equipment_groups }: IrisEquipmentGroupsResponse): string[] => {
  const group = equipment_groups.find(entry => entry.classifier === MESSAGES_AND_ACTION_LOGS)?.group;
  return [
    ...new Set(
      (group || '')
        .split(',')
        .map(name => name.trim())
        .filter(Boolean)
    )
  ];
};

export const loadIrisEquipmentGroups = (machineId: string, signal: AbortSignal) =>
  axios.get<IrisEquipmentGroupsResponse>(`/v2/machines/${machineId}/iris-equipment-groups`, {
    params: { classifier: MESSAGES_AND_ACTION_LOGS },
    signal
  });

export const updateIrisEquipmentGroups = (machineId: string, groups: string[], signal: AbortSignal) =>
  axios.put<IrisEquipmentGroupsResponse>(
    `/v2/machines/${machineId}/iris-equipment-groups`,
    convertEmptyToNull({ equipment_groups: [{ classifier: MESSAGES_AND_ACTION_LOGS, group: groups.join(',') }] }),
    { signal }
  );
